// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\"> <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"> <path d=\"M3 8.995l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z\"/> <path d=\"M9 21.995v-10h6v10\"/> </g> </svg>";
// Exports
module.exports = code;